import { ApplicationElement, html } from '@crossiety/lit-components';
import style from './style.lit.css';

/**
 * List item with title, info and left and right slots
 *
 * @prop name - Title (string, optional).
 * @prop info - Additional description (string, optional).
 * @prop breakFirstXs - Should component breaks first slot in new line below 768px ( boolean, optional )
 * @prop breakLastXs - Should component breaks last slot in new line below 768px ( boolean, optional )
 * @prop alignH - Horizontal align content (options: top, center, end).
 * @prop slot_1 - name=left
 * @prop slot_2 - name=right
 * @prop slot_3 - name=main (Replacement for info & title property if there is need for HTML content)
 */
export default class ListItem10 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    name: { type: String },
    info: { type: String },
    breakFirstXs: { type: Boolean },
    breakLastXs: { type: Boolean },
    alignH: { type: String, reflect: true },
  };

  constructor() {
    super();
    this.alignH = 'center';
  }

  firstUpdated() {
    const slots = this.shadowRoot.querySelectorAll('slot');
    slots.forEach(slot => {
      this.classList.add(`slot-${slot.name}-empty`);
    });
  }

  onSlotChange(e) {
    const cssClass = `slot-${e.currentTarget.name}-empty`;

    e.currentTarget.assignedNodes().length === 0
      ? this.classList.add(cssClass)
      : this.classList.remove(cssClass);
  }

  renderTitle() {
    return html`<h3 class="title">${this.name}</h3>`;
  }

  renderInfo() {
    return html`<div class="info">${this.info}</div>`;
  }

  render() {
    return html`
      <slot name="left" @slotchange="${this.onSlotChange}"></slot>
      <main>
        ${this.name && this.renderTitle()} ${this.info && this.renderInfo()}
        <slot name="main" @slotchange="${this.onSlotChange}"></slot>
      </main>
      <slot name="right" @slotchange="${this.onSlotChange}"></slot>
    `;
  }
}

customElements.get('xs-list-item-10') ||
  customElements.define('xs-list-item-10', ListItem10);
